import q from 'q'
import superagent from 'superagent'
import metrics from './metrics'

const REQUEST_TIMEOUT = 60000
const SEARCH_ENDPOINT = 'https://edstandards.smarttech.com/standards/search'
const LOOKUP_ENPOINT = 'https://edstandards.smarttech.com/standards/'
const SMART_API_KEY = 'N2EwMzdhZmZlNmYxNDQyMTkxZThjNWM0MGU5MDFjZ'
let activeSearchRequest = null

/**
 * search for standard sets
 * @param subject
 * @param grade
 * @param set
 * @param query
 */
let search = (subject, grade, set, query) => {
  let deferred = q.defer()
  let queryString = queryStringBuilder({subject, grade, set, q: query, limit: 50})
  let request = superagent('GET', SEARCH_ENDPOINT)
  request.timeout(REQUEST_TIMEOUT)
  request.set('X-API-Key', SMART_API_KEY)
  request.query(queryString)
  request.end(function (error, response) {
    activeSearchRequest = null
    if (error) {
      deferred.reject(error)
      metrics
        .sendMetric(metrics.CATEGORIES.THIRD_PARTY_CALLS, metrics.CP_TAGS.EDGATE_SEARCH_FAILURE, 1, metrics.TYPE.FAILURE_COUNTER, error)
    } else {
      deferred.resolve(response)
      metrics
        .sendMetric(metrics.CATEGORIES.THIRD_PARTY_CALLS, metrics.CP_TAGS.EDGATE_SEARCH_SUCCESS, 1, metrics.TYPE.OCCURRENCE_COUNTER)
    }
  })
  activeSearchRequest = request
  return deferred.promise
}

/**
 * Aborts the active search request
 */
let cancelSearch = () => {
  if (activeSearchRequest) {
    activeSearchRequest.abort()
  }
  activeSearchRequest = null
}

let lookup = (guid) => {
  let deferred = q.defer()
  let request = superagent('GET', LOOKUP_ENPOINT + guid)
  request.timeout(REQUEST_TIMEOUT)
  request.set('X-API-Key', SMART_API_KEY)
  request.end(function (error, response) {
    if (error) {
      deferred.reject(error)
      metrics
        .sendMetric(metrics.CATEGORIES.THIRD_PARTY_CALLS, metrics.CP_TAGS.EDGATE_SEARCH_FAILURE, 1, metrics.TYPE.FAILURE_COUNTER, error)
    } else {
      deferred.resolve(response)
      metrics
        .sendMetric(metrics.CATEGORIES.THIRD_PARTY_CALLS, metrics.CP_TAGS.EDGATE_SEARCH_SUCCESS, 1, metrics.TYPE.OCCURRENCE_COUNTER)
    }
  })
  return deferred.promise
}

/**
 * builds a query string
 * @param params
 * @returns {string}
 */
let queryStringBuilder = (params) => {
  let query = []
  for (let param in params) {
    if (params[[param]]) {
      query.push(encodeURIComponent(param) + '=' + encodeURIComponent(params[param]))
    }
  }
  return query.join('&')
}

export default {
  search,
  lookup,
  cancelSearch
}
